var AIChatWindow = React.createClass({
    getInitialState: function () {
        return { chatItems: [], conversationId: '', addScrollEvent: true, stopEventScroll: false };
    },

    componentDidMount: function () {
        let sessionGenAIResponse = JSON.parse(sessionStorage.getItem("genAIResponse"));
        if (sessionGenAIResponse && sessionGenAIResponse.length) {
            this.setState({ chatItems: sessionGenAIResponse });
        }
    },

    componentDidUpdate: function () {
        let activeTab = document.getElementsByClassName("tab-pane active")[0].id;
        if (this.state.addScrollEvent) {
            let chatApp = document.getElementsByClassName("ai-chat-app");
            if (chatApp && chatApp.length > 0) {
                chatApp = chatApp[0];
                let kbTabPaneId = chatApp.closest(".tab-pane").id;
                
                if (activeTab !== kbTabPaneId) {
                    let that = this;
                    document.querySelectorAll(`a[href="#${kbTabPaneId}"]`).forEach((kbLink) => {
                        let kbTab = kbLink.closest("li");
                        if (kbTab) {
                            kbTab.addEventListener("click", that.handleScrollEvent.bind(that));
                            that.setState({ addScrollEvent: false });
                        }
                    });
                }
            }
        }
        this.handleScroll();
    },

    handleScroll: function () {
        let messageContainer = document.querySelector(".ai-chat-message-container");
        let lastUserMsg = document.querySelectorAll(".ai-chat-message-item.user");
        
        if (messageContainer && lastUserMsg && lastUserMsg.length > 0) {
            lastUserMsg = lastUserMsg[lastUserMsg.length -1];
            let lastMsgOffset = lastUserMsg.offsetTop;
            lastMsgOffset = lastMsgOffset > 25 ? lastMsgOffset - 25 : lastMsgOffset;
            messageContainer.scrollTo({
                top: lastMsgOffset,
                behavior: "smooth"
            });
        }
    },

    handleScrollEvent: function () {
        let that = this;
        if (!that.state.stopEventScroll) {
            setTimeout(() => {
                let chatApp = document.getElementsByClassName("ai-chat-app");
                if (chatApp && chatApp.length > 0) {
                    chatApp = chatApp[0];
                    let kbTab = chatApp.closest(".tab-pane");

                    if (kbTab.classList.contains("active")) {
                        that.handleScroll();
                        that.setState({ stopEventScroll: true });
                    }
                }
            }, 100);
        }
    },

    handleBotResponse: function (botResponse) {
        if (!botResponse) {
            return;
        }
        this.setState({ conversationId: botResponse.conversationId });
        var chatItem = {
            requestText: botResponse.requestText,
            details: botResponse.message,
            conversationId: botResponse.conversationId,
            isInterrogativeOrRequest: botResponse.isInterrogativeOrRequest,
            sender: 'bot',
            contextCleared: botResponse.contextCleared
        };
        var chatItems = this.state.chatItems.concat([chatItem]);
        sessionStorage.setItem("genAIResponse", JSON.stringify(chatItems));
        this.setState({ chatItems: chatItems });
    },

    handleUserMessage: function (userMessage) {
        var newUserMessage = { details: { text: userMessage }, sender: 'user' };
        var updatedMessages = this.state.chatItems.concat([newUserMessage]);
        this.setState({ chatItems: updatedMessages });
    },

    resetMessages: function () {
        this.setState({ chatItems: [] });
        sessionStorage.removeItem("genAIResponse");
    },

    render: function () {
        var self = this;
        var chatItems = this.state.chatItems.map(function (chatItem, index) {
            return <AIChatMessage key={index} chatItem={chatItem} />;
        });

        return (
            <div className="chat-window">
                <div className="ai-chat-message-container">
                    {chatItems}
                </div>
                <AIMessageInput 
                    onBotResponse={this.handleBotResponse} 
                    onUserMessage={this.handleUserMessage} 
                    onSearchChanged={this.resetMessages}
                    setIsInterrogativeFirstRequestGpt={this.props.setIsInterrogativeFirstRequestGpt}
                />
            </div>
        );
    }
});
